var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSquareRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-square-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.0257 13.4344L13.3526 10.0946M13.3526 10.0946L10.0129 6.7677M13.3526 10.0946L6.68598 10.1074M6.53375 17.6078L13.5337 17.5943C14.9339 17.5916 15.6339 17.5902 16.1682 17.3167C16.6381 17.0761 17.0198 16.6929 17.2586 16.2221C17.5301 15.6868 17.5287 14.9867 17.526 13.5866L17.5126 6.5866C17.5099 5.18647 17.5085 4.4864 17.235 3.95215C16.9944 3.48221 16.6112 3.10049 16.1404 2.86171C15.6051 2.59026 14.905 2.59161 13.5049 2.5943L6.50488 2.60778C5.10475 2.61047 4.40468 2.61182 3.87043 2.88533C3.40049 3.12592 3.01877 3.50911 2.77999 3.97998C2.50854 4.51528 2.50989 5.21534 2.51258 6.61547L2.52606 13.6155C2.52875 15.0156 2.5301 15.7157 2.80361 16.2499C3.0442 16.7198 3.42739 17.1016 3.89826 17.3403C4.43356 17.6118 5.13362 17.6104 6.53375 17.6078Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareRight);
export default __webpack_public_path__ + "static/media/arrow-square-right.914fc96cf5e731031beebf6b70d7f287.svg";
export { ForwardRef as ReactComponent };